<template>
  <div class="mx-0">
    <v-dialog v-model="warning" persistent max-width="290">
      <v-card>
        <v-card-title>
          <v-icon color="secondary">error</v-icon>
          <span></span>
          <span class="secondary--text">
            <strong>{{ $t('common.warning') }}</strong>
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <p class="grey--text">{{ message }}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="secondary" @click.stop="okAction">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["warning", "message"],
  methods: {
    okAction() {
        this.$emit("okAction");
    }
  }
};
</script>

<style>
</style>
  